<div class="content" [ngClass]="activeTab == 'onboarding' && !isStoreLogo ? 'without_logo_section' : '' ">
  <app-panther-lake-onboarding *ngIf="activeTab === 'onboarding'"></app-panther-lake-onboarding>
  <app-panther-lake-overview *ngIf="activeTab === 'overview'"></app-panther-lake-overview>
  <app-panther-lake-specs-page *ngIf="activeTab === 'specs'"></app-panther-lake-specs-page>
  <app-panther-lake-va-page *ngIf="activeTab === 'va'"></app-panther-lake-va-page>
  <app-compare-devices #compareDevicesRef *ngIf="activeTab === 'compare'"></app-compare-devices>
</div>

<button class="compare-button" *ngIf="activeTab !== 'va' && activeTab !== 'onboarding' && activeTab !== 'compare'" [routerLink]="[]" [queryParams]="{ activeTab: 'compare' }" (click)="onNavClick('compare')" [ngClass]="{'ptl-std-compare-button': isPantherLakeStd, 'intelOne-display': setIntelDisplayOneFont}" type="button" aria-label="Compare this device">
  <span class="compare-icon" aria-hidden="true">
    <img src="assets/images/compare-btn-icon.svg" alt="compare-btn-icon">
  </span>
  <span class="compare-text" [innerHTML]="compareButtonText"></span>
</button>
